import { useLingui } from '@lingui/react/macro';
import { useDonationCount } from '../donation-count';
import { DonationOdometer } from './donation-odometer';

/** Counts from the visitor's arrival on the site, not this card's mount: see `-components/donation-count.ts`. */
export function LiveDonations() {
	const { t } = useLingui();
	const count = useDonationCount();

	// Stacked below `sm`: three 74px tiles that never shrink leave the copy narrower than its longest
	// word on a phone, which scrolls the page sideways.
	return (
		<div className="bg-apricot flex flex-col items-start gap-4 rounded-2xl p-3 sm:flex-row sm:items-center sm:gap-10">
			<DonationOdometer count={count} />
			<p className="text-ink/80 max-w-[19.5rem] min-w-0 text-sm leading-[1.5] tracking-[-0.02em] sm:text-base">
				{t`Donations we have received while you have been on this site.`}
			</p>
		</div>
	);
}
